




import { defineComponent, onMounted } from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';

import { logout } from '@/api';

const Logout = defineComponent({
  setup() {
    const { router } = useRouter();

    onMounted(async () => {
      logout();
      router.push({ name: 'Login' });
    });
  },
});

export default Logout;
